import React from 'react';
import ContextualLink from '@magoosh/gre/app/contextual_link';
import { paths } from 'config/path_helpers';

import { DefaultButton } from '@magoosh/lib/button';
import EndOfPlanPreviewIcon from '@magoosh/gre/adaptive_prep_v2/assets/icons/end_of_plan_preview_icon.svg';
import StudyDayCompleteIllustration from '@magoosh/gre/adaptive_prep_v2/assets/illustrations/study_day_complete.svg';
import style from './style.module.scss';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface ActionProps {
  isLoadingMoreChunks: boolean;
  fetchMoreChunks: () => void;
}

export const SeeTomorrow: React.FC<ActionProps> = ({ isLoadingMoreChunks, fetchMoreChunks }) => (
  <div className="text-center">
    <DefaultButton
      className={style.blockButtonOnMobile}
      onClick={fetchMoreChunks}
      submitting={isLoadingMoreChunks}>
      See Tomorrow
    </DefaultButton>
  </div>
);

export const SeeMore: React.FC<ActionProps> = ({ isLoadingMoreChunks, fetchMoreChunks }) => (
  <div className="text-center">
    <DefaultButton
      className={style.blockButtonOnMobile}
      onClick={fetchMoreChunks}
      submitting={isLoadingMoreChunks}>
      See More
    </DefaultButton>
  </div>
);

export const SeeMoreWithTopicLibraryNudge: React.FC<ActionProps> = ({ isLoadingMoreChunks, fetchMoreChunks }) => (
  <>
    <div className="text-center">
      <div>
        <DefaultButton
          className={style.blockButtonOnMobile}
          onClick={fetchMoreChunks}
          submitting={isLoadingMoreChunks}>
          See More
        </DefaultButton>
      </div>

      <div className="u-margin-T-l">
        <ContextualLink href="#top" style={{color: colors.grayDarker}}>Back to Top</ContextualLink>
      </div>

      <div className="bg-gray-lighter border-radius u-margin-T-m u-padding-V-s u-padding-H-m">
        <div className="d-flex align-items-center justify-content-between  flex-column flex-sm-row">
          <div>
            <h4 className="u-margin-V-xs">
              Looking for a specific topic?
            </h4>
          </div>

          <div>
            <ContextualLink href={paths.topicOverview()}>
              <DefaultButton className={style.blockButtonOnMobile}>Go To Topic Library</DefaultButton>
            </ContextualLink>
          </div>
        </div>
      </div>
    </div>
  </>
);

export const EndOfPlanPreview: React.FC = () => (
  <>
    <hr />
  
    <div className="text-center">
      <img src={EndOfPlanPreviewIcon} alt="" />

      <h4 className="u-margin-T-s">You’ve Reached the End of Your Study Plan Preview</h4>
      <p>
        {/* TODO - real copy */}
        At your current pace you’ll complete all Checkpoints in about 15 more study days.  And beyond that, Magoosh has enough content to help you study for as long as you need.
      </p>

      <div>
        <DefaultButton className={style.blockButtonOnMobile} href="#top">Back to Top</DefaultButton>
      </div>

      <div className="u-margin-T-l">
        <ContextualLink href={paths.topicOverview()} style={{color: colors.grayDarker}}>
          Go to Topic Library
        </ContextualLink>
      </div>
    </div>
  </>
);

export const ChunkCompleted = () => (
  <div className="text-center u-margin-B-s">
    <img
      alt="Illustration of three students celebrating"
      className="u-margin-V-m"
      src={StudyDayCompleteIllustration}
    />

    <h4>
      <strong>Hooray!</strong>
    </h4>
    <p>You completed all of the recommended study activities for today!</p>
  </div>
);
